import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { CommonService } from 'src/app/shared/utils/common.service';
import {
  IDeviceType,
  IDeviceTypes,
} from '../../building-unit-details/device-management/device-management.interfaces';
import { IUpdateDeviceParams } from '../device-setting.interfaces';
import { DeviceSettingsService } from '../device-settings.service';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-change-device-type',
  templateUrl: './change-device-type.component.html',
  styleUrls: ['./change-device-type.component.scss'],
})
export class ChangeDeviceTypeComponent implements OnInit {
  /**
   * all necessary input get values from parent
   */
  @Input() formGroupName!: string;
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  @Output() updateDeviceInfoSyc = new EventEmitter<IUpdateDeviceParams>();
  readonly LANG_CONST = LANG_CONST;
  errorMessage: string = '';
  formGroup!: FormGroup;
  radionButtons: IDeviceTypes | undefined;
  existingType: string = '';

  get formInstance() {
    return this.formGroup?.controls;
  }

  constructor(
    private rootFormGroup: FormGroupDirective,
    private deviceSettingservice: DeviceSettingsService,
    private notificationService: NotificationService,
    private commonService: CommonService,
    private localizationService: LocalizationService,
    private translate: TranslateService
  ) {}

  /**
   * @description this is onInit life cycle method
   */
  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.formGroup = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
    // radio button list manage for active status
    this.radionButtons = [
      {
        label: this.translate.instant('COMBO_READER_DEVICE'),
        value: this.translate.instant('COMBO_READER_DEVICE'),
        active: false,
      },
      {
        label: this.translate.instant('CONTROLLER_DEVICE'),
        value: this.translate.instant('CONTROLLER_DEVICE'),
        active: false,
      },
    ];

    this.radionButtons.map((deviceType: IDeviceType) => {
      if (deviceType.value === this.formInstance?.deviceType.value) {
        deviceType.active = true;
      }
    });
    this.existingType = this.formInstance?.deviceType?.value;
  }

  /**
   * @description current selected group index mark as active status
   * @param userGroup active number
   */
  activate(deviceType: IDeviceType): void {
    this.radionButtons?.map((option: any) => (option.active = false));
    deviceType.active = true;
  }

  /**
   * @description close modal dialogue with help of material service
   * @returns void
   */
  closeDialog(): void {
    this.dialogRef?.close();
  }

  /**
   * @description navigate to back screen
   * @returns void
   */
  navigateBack(): void {
    this.stepperChange.emit((this.stepper = 1));
    this.formInstance?.deviceType.patchValue(this.existingType);
  }

  /**
   * @description #changeDeviceType function will update the device type by calling
   *               updatePartnerDeviceType API.
   * @returns void
   */

  changeDeviceType(): void {
    this.deviceSettingservice
      .updatePartnerDeviceType(
        this.formInstance.deviceId.value,
        this.formInstance.deviceType.value
      )
      .subscribe({
        next: (res: any) => {
          if (res && res?.updatePartnerDevice?.deviceId) {
            //passing updated value directly
            this.updateDeviceInfoSyc.emit({
              deviceType: String(this.formInstance.deviceType.value),
            });
            this.stepperChange.emit((this.stepper = 1));
            this.notificationService.showSuccess(
              this.commonService.stringInterPolation(
                this.translate.instant('UPDATED_SUCCESSFULLY'),
                this.translate.instant('DEVICE')
              )
            );
          }
        },
        error: (err: Error) => {
          if (window.__dev__) console.log('updateDevice', err);
          this.notificationService.showError(err?.message);
        },
      });
  }
}
